import React from "react";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import ReactTable from "react-table";
import moment from "moment";
import _ from "lodash";
import { DatePicker } from "antd";
import {
    Menu,
    Item,
    MenuProvider
} from "react-contexify";
import {
    Form
} from "react-bootstrap";
import ReactTooltip from "react-tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "react-contexify/dist/ReactContexify.min.css";
import storeTravelChargeTypes from "data/store-travel-charge-types";
import WorkersList from "components/worker/WorkersList";
import { fetchServiceTypes } from "actions/serviceTypeActions";
import { findItemValueByIdFromArray } from "functions/find-item-by-id-from-array";
import {
    updateJob,
    batchEditCell
} from "actions/draftActions";

const WorkerContextMenuId = "worker-context-menu-id";
class WorkerContextMenu extends React.Component {
    constructor(props) {
        super(props);
        this.handleCLick = this.handleCLick.bind(this);
    }

    handleCLick = ({ event, props }) => {
        event.preventDefault();
        props.callback(props.id, props.actionType);
    };

    render() {
        return (
            <Menu id={WorkerContextMenuId} animation="fade">
                <Item onClick={this.handleCLick}>
                    Replace worker
                </Item>
            </Menu>
        );
    }
}

const bulkEditMenuId = "bulk-edit-context-menu";
class BulkEditContextMenu extends React.Component {
    constructor(props) {
        super(props);
        this.handleCLick = this.handleCLick.bind(this);
    }

    handleCLick = ({ event, props }) => {
        event.preventDefault();
        props.callback(props.propName, props.value, props.filteredData);
    };

    render() {
        return (
            <Menu id={bulkEditMenuId} animation="fade">
                <Item onClick={this.handleCLick}>
                    Apply to all fields
                </Item>
            </Menu>
        );
    }
}

class DetailsTable extends React.Component {
    dateFormat = "YYYY-MM-DD";

    constructor(props) {
        super(props);

        this.state = {
            currentData: this.props.draftsDetails,
            tableState: {
                page: 0,
                pageSize: 20,
                sorted: [
                    {
                        id: "retailer",
                        desc: false
                    }
                ]
            },
        };

        // this.fetchTableData = this.fetchTableData.bind(this);

        this.handleSortedChange = this.handleSortedChange.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handlePageSizeChange = this.handlePageSizeChange.bind(this);

        this.updateServiceType = this.updateServiceType.bind(this);
        this.reactTable = React.createRef();

        this.props.fetchServiceTypes();
    }

    componentDidMount() {
        this.props.handleTableChange(this.state.tableState);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            currentData: nextProps.draftsDetails
        }, this.onTableViewChange);
    }

    componentDidUpdate() {
        this.adjustHeaders();
    }

    componentWillUnmount() {
        this.props.fetchServiceTypes(true);
    }

    onInputBlur = (rowId, fieldName, newValue, oldValue) => {
        // console.error("onInputBlur", rowId, fieldName, newValue, oldValue);
        if (newValue !== oldValue) {
            this.props.batchEditCell(rowId, fieldName, newValue);
        }
    };

    bulkEditData = (propName, value) => ({
        propName,
        value,
        callback: this.props.handleBulkEdit,
        filteredData: (this.state.currentData || this.props.currentData)
    });

    adjustHeaders = () => {
        const tableBody = document.querySelector(".rt-tbody");
        if (tableBody) {
            const tBodyWidth = tableBody.clientWidth;
            const tBodyStyle = window.getComputedStyle(tableBody);
            if (tBodyStyle && tBodyStyle.width) {
                const tBodyOuterWidth = parseInt(tBodyStyle.width.slice(0, -2), 0);
                const headerRows = document.querySelectorAll(".rt-thead > .rt-tr");

                if (headerRows) {
                    const margin =
                        tBodyWidth < tBodyOuterWidth ? tBodyOuterWidth - tBodyWidth : 0;

                    headerRows.forEach(r => {
                        r.style.marginRight = `${margin + 1}px`;
                    });
                }
            }
        }
    };

    filterCaseInsensitive = (filter, row) => {
        const id = filter.pivotId || filter.id;
        if (id === "startDate") {
            if (filter.value === null) {
                return true;
            }
            return row[id] >= filter.value;
        }
        if (id === "endDate") {
            if (filter.value === null) {
                return true;
            }
            return row[id] <= filter.value;
        }
        return row[id] !== undefined && row[id] !== null
            ? row[id]
                .toString()
                .toLowerCase()
                .includes(filter.value.toString().toLowerCase())
            : false;
    };

    onTableViewChange = () => {
        const current = this.reactTable.current;
        if (current) {
            const currentData = current
                .getResolvedState()
                .sortedData.map(item => item._original);
            this.setState({ currentData });
        }
    };

    formatAddress = store => {
        const result = [];
        if (store.address1) {
            result.push(store.address1);
        }
        if (store.address2) {
            result.push(store.address2);
        }
        if (store.postalCode) {
            result.push(store.postalCode);
        }

        return result.join("<br/>");
    };

    /*
    fetchTableData(state) {
        this.props.handleTableChange(this.state.tableState);
    }
    */

    updateServiceType = (jobId, draftId, jobProductId, helperJobProductId, serviceTypeId) => {
        this.props.updateJob(
            jobId,
            draftId,
            jobProductId,
            helperJobProductId,
            serviceTypeId,
            this.props.handleRefreshPage
        );
    };

    handlePageChange = (pageIndex) => {
        const tableState = Object.assign({}, this.state.tableState);
        tableState.page = pageIndex;
        this.setState({
            tableState
        }, () => {
            this.props.handleTableChange(tableState);
        });
    };

    handleSortedChange = (sorted) => {
        const tableState = Object.assign({}, this.state.tableState);
        tableState.sorted = sorted;
        this.setState({
            tableState
        }, () => {
            this.props.handleTableChange(tableState);
        });
    };

    handlePageSizeChange = (pageSize) => {
        const tableState = Object.assign({}, this.state.tableState);
        tableState.pageSize = pageSize;
        this.setState({
            tableState
        }, () => {
            this.props.handleTableChange(tableState);
        });
    };

    render() {
        const {
            serviceTypes,
            inputsReadOnly,
            handleModal,
            draftsDetails,

            loading,
            pages,
            page,

            handleDeleteWorker,
            handleWorkerProfileModal,
            handleClickCurrentWorker
        } = this.props;

        // console.error("draftsDetails", draftsDetails);

        const columns = [
            {
                Header: "Retailer",
                accessor: "retailer",
                id: "retailer",
                minWidth: 50,
                maxWidth: 150,
                style: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                },
                Filter: ({ filter, onChange }) => (
                    <select
                        onChange={event => onChange(event.target.value)}
                        style={{ width: "100%", height: "100%" }}
                        value={filter ? filter.value : ""}
                    >
                        <option value="">Show All</option>

                        {this.state.currentData &&
                        _.uniq(this.state.currentData.map(item => item.retailer)).map(
                            filterItem => (
                                <option key={filterItem} value={filterItem}>
                                    {filterItem}
                                </option>
                            )
                        )}
                    </select>
                )
            },
            {
                Header: "Store #",
                accessor: "store.storeNumber",
                id: "storeNumber",
                minWidth: 50,
                maxWidth: 150,
                style: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                },
                Filter: ({ filter, onChange }) => (
                    <select
                        onChange={event => onChange(event.target.value)}
                        style={{ width: "100%", height: "100%" }}
                        value={filter ? filter.value : ""}
                    >
                        <option value="">Show All</option>

                        {this.state.currentData &&
                        _.uniq(
                            this.state.currentData.map(item => item.store.storeNumber)
                        ).map(filterItem => (
                            <option key={filterItem} value={filterItem}>
                                {filterItem}
                            </option>
                        ))}
                    </select>
                ),
                Cell: ({ original }) => (
                    <div className="w-100 d-flex justify-content-between">
                        <div>
                            <div
                                data-tip={true}
                                data-for={`store-number-${original.id}`}
                                data-place="right"
                            >
                                {original.store.storeNumber}
                            </div>
                            <ReactTooltip id={`store-number-${original.id}`} effect='solid'>
                                <div className="text-left" dangerouslySetInnerHTML={{
                                    __html: this.formatAddress(original.store)
                                }} />
                            </ReactTooltip>
                        </div>
                        {original.store.isTravelAssociated
                            ?
                            <span>
                                <FontAwesomeIcon
                                    icon="car"
                                    size="lg"
                                    data-tip
                                    data-for={`store-travel-charge-${original.id}`}
                                />
                                <ReactTooltip id={`store-travel-charge-${original.id}`} effect="float">
                                    <div>
                                        {`Travel Charges: ${storeTravelChargeTypes[original.store.travelChargeType]} ${original.store.travelCharge ? `$${original.store.travelCharge}` : ""}`}
                                    </div>
                                </ReactTooltip>
                            </span>
                        : null}
                    </div>
                )
            },
            {
                Header: "Province",
                accessor: "store.province",
                id: "province",
                minWidth: 50,
                maxWidth: 150,
                style: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                },
                Filter: ({ filter, onChange }) => (
                    <select
                        onChange={event => onChange(event.target.value)}
                        style={{ width: "100%", height: "100%" }}
                        value={filter ? filter.value : ""}
                    >
                        <option value="">Show All</option>
                        {this.state.currentData &&
                        _.uniq(
                            this.state.currentData.map(item => item.store.province)
                        ).map(filterItem => (
                            <option key={filterItem} value={filterItem}>
                                {filterItem}
                            </option>
                        ))}
                    </select>
                )
            },
            {
                Header: "City",
                accessor: "store.city",
                id: "city",
                style: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                },
                Filter: ({ filter, onChange }) => (
                    <select
                        onChange={event => onChange(event.target.value)}
                        style={{ width: "100%", height: "100%" }}
                        value={filter ? filter.value : ""}
                    >
                        <option value="">Show All</option>

                        {this.state.currentData &&
                        _.uniq(this.state.currentData.map(item => item.store.city)).map(
                            filterItem => (
                                <option key={filterItem} value={filterItem}>
                                    {filterItem}
                                </option>
                            )
                        )}
                    </select>
                ),
                Cell: ({ original }) => (
                    <div className="w-100 d-flex justify-content-between">
                        <span>{original.store.city}</span>
                        {original.store.isTravelRegion
                            ?
                            <span>
                                <FontAwesomeIcon
                                    icon="car"
                                    size="lg"
                                    data-tip
                                    data-for={`city-travel-charge-${original.id}`}
                                />
                                <ReactTooltip id={`city-travel-charge-${original.id}`} effect="float">
                                    <div>
                                        {`Travel Charges: ${storeTravelChargeTypes[original.store.cityTravelChargeType]} ${original.store.cityTravelCharge ? `$${original.store.cityTravelCharge}` : ""} `}
                                    </div>
                                </ReactTooltip>
                            </span>
                            : null}
                    </div>
                )
            },
            /* {
                Header: "Address",
                id: "address",
                style: {
                    whiteSpace: "unset"
                },
                accessor: original => original.store.address1 + original.store.address2,
                Cell: ({ original }) => this.formatAddress(original.store)
            }, */
            {
                Header: "Job",
                accessor: "mainJobProduct.jobNumber",
                id: "mainJob",
                style: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                },
                Filter: ({ filter, onChange }) => (
                    <select
                        onChange={event => onChange(event.target.value)}
                        style={{ width: "100%", height: "100%" }}
                        value={filter ? filter.value : ""}
                    >
                        <option value="">Show All</option>

                        {this.state.currentData &&
                        _.uniq(
                            this.state.currentData.map(
                                item => item.mainJobProduct.jobNumber
                            )
                        ).map(filterItem => (
                            <option key={filterItem} value={filterItem}>
                                {filterItem}
                            </option>
                        ))}
                    </select>
                )
            },
            {
                Header: "Helper Job",
                accessor: "helperJobProduct.jobNumber",
                id: "helperJob",
                Filter: ({ filter, onChange }) => (
                    <select
                        onChange={event => onChange(event.target.value)}
                        style={{ width: "100%", height: "100%" }}
                        value={filter ? filter.value : ""}
                    >
                        <option value="">Show All</option>

                        {this.state.currentData &&
                        _.uniq(
                            this.state.currentData.map(
                                item => (item.helperJobProduct ?  item.helperJobProduct.jobNumber : "")
                            )
                        ).map(filterItem => (
                            <option key={filterItem} value={filterItem}>
                                {filterItem}
                            </option>
                        ))}
                    </select>
                )
            },
            {
                Header: "Product",
                accessor: "mainJobProduct.product",
                id: "product",
                style: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                },
                Filter: ({ filter, onChange }) => (
                    <select
                        onChange={event => onChange(event.target.value)}
                        style={{ width: "100%", height: "100%" }}
                        value={filter ? filter.value : ""}
                    >
                        <option value="">Show All</option>

                        {this.state.currentData &&
                        _.uniq(
                            this.state.currentData.map(item => item.mainJobProduct.product)
                        ).map(filterItem => (
                            <option key={filterItem} value={filterItem}>
                                {filterItem}
                            </option>
                        ))}
                    </select>
                )
            },
            {
                Header: "Service Type",
                accessor: "serviceType",
                id: "serviceTypeId",
                style: {
                    width: 200
                },
                className: "g-overflow-visible",
                Cell: ({ original }) => {
                    const value = parseInt(original.serviceTypeId, 10);
                    const draftId = original.draftId;
                    const options = serviceTypes.map((value) => ({
                            label: value.name,
                            value: parseInt(value.id, 10)
                        }));
                    const optionValue = findItemValueByIdFromArray(
                        options,
                        "value",
                        value
                    ) || null;
                    // index, fieldName
                    // serviceTypeId, jobId, draftId, jobProductId, helperJobProductId
                    return (
                        <div className="w-100">
                            <select
                                className="form-control"
                                value={optionValue ? optionValue.value : ""}
                                onChange={(event) => {
                                    this.updateServiceType(
                                        original.draftJobProductId,
                                        original.draftId,
                                        original.mainJobProduct.id,
                                        original.helperJobProduct
                                            ? original.helperJobProduct.id
                                            : null,
                                        event.target.value
                                    );
                                }}
                                disabled={inputsReadOnly[draftId]}
                            >

                                <option
                                    value=""
                                    disabled={true}
                                >
                                    -
                                </option>

                                {options.map((value) => (
                                    <option key={value.value} value={value.value}>
                                        {value.label}
                                    </option>
                                ))}
                            </select>
                        </div>
                    );
                },
            },
            {
                Header: "Trait",
                accessor: "trait",
                Cell: ({ index, column }) => {
                    const rowId = draftsDetails[index].id;
                    const value = draftsDetails[index][column.id];
                    const draftId = draftsDetails[index].draftId;
                    return (
                        <MenuProvider
                            id={bulkEditMenuId}
                            data={this.bulkEditData(
                                column.id,
                                value
                            )}
                        >
                            <Form.Control
                                type="text"
                                defaultValue={value}
                                onBlur={event =>
                                    this.onInputBlur(
                                        rowId,
                                        column.id,
                                        event.target.value,
                                        value
                                    )
                                }
                                disabled={inputsReadOnly[draftId]}
                            />
                        </MenuProvider>
                    );
                },
                id: "trait",
                getProps: () => ({
                    style: {
                        display: "block"
                    }
                }),
                Filter: ({ filter, onChange }) => (
                    <select
                        onChange={event => onChange(event.target.value)}
                        style={{ width: "100%", height: "100%" }}
                        value={filter ? filter.value : ""}
                    >
                        <option value="">Show All</option>

                        {this.state.currentData &&
                        _.uniq(this.state.currentData.map(item => item.trait)).map(
                            filterItem => (
                                <option key={filterItem} value={filterItem}>
                                    {filterItem}
                                </option>
                            )
                        )}
                    </select>
                )
            },
            {
                Header: "Hours",
                accessor: "hours",
                Cell: ({ index, column }) => {
                    const rowId = draftsDetails[index].id;
                    const value = draftsDetails[index][column.id];
                    const draftId = draftsDetails[index].draftId;
                    return (
                        <MenuProvider
                            id={bulkEditMenuId}
                            data={this.bulkEditData(
                                column.id,
                                value
                            )}
                        >
                            <Form.Control
                                type="number"
                                min={0}
                                step={0.25}
                                defaultValue={value}
                                onBlur={event =>
                                    this.onInputBlur(
                                        rowId,
                                        column.id,
                                        event.target.value,
                                        value
                                    )
                                }
                                disabled={inputsReadOnly[draftId]}
                            />
                        </MenuProvider>
                    );
                },
                id: "hours",
                getProps: () => ({
                    style: {
                        display: "block"
                    }
                }),
                style: {
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                },
                Filter: ({ filter, onChange }) => (
                    <select
                        onChange={event => onChange(event.target.value)}
                        style={{ width: "100%", height: "100%" }}
                        value={filter ? filter.value : ""}
                    >
                        <option value="">Show All</option>

                        {this.state.currentData &&
                        _.uniq(this.state.currentData.map(item => item.hours)).map(
                            filterItem => (
                                <option key={filterItem} value={filterItem}>
                                    {filterItem}
                                </option>
                            )
                        )}
                    </select>
                )
            },
            {
                Header: "Start Date",
                accessor: original => moment(original.startDate),
                id: "startDate",
                Cell: ({ original, index }) => {
                    const rowId = draftsDetails[index].id;
                    const startDate =
                        original.startDate !== "" ? moment(original.startDate) : null;
                    const endDate =
                        original.endDate !== "" ? moment(original.endDate) : null;
                    const value = original.startDate;
                    const draftId = draftsDetails[index].draftId;

                    return (
                        <MenuProvider
                            id={bulkEditMenuId}
                            data={this.bulkEditData(
                                "startDate",
                                value
                            )}
                        >
                            {inputsReadOnly[draftId]
                                ?
                                <Form.Control
                                    type="text"
                                    defaultValue={startDate ? startDate.format(this.dateFormat) : ""}
                                    disabled={inputsReadOnly[draftId]}
                                />
                                :
                                <DatePicker
                                    value={startDate}
                                    format={this.dateFormat}
                                    onChange={date => {
                                        const dateString = date === null ? "" : date.format(this.dateFormat);
                                        this.onInputBlur(rowId, "startDate", dateString, false);
                                    }}
                                    disabled={inputsReadOnly[draftId]}
                                    disabledDate={(current) => current && current > endDate}
                                    allowClear={false}
                                />
                            }
                        </MenuProvider>
                    );
                },
                Filter: ({ filter, onChange }) => (
                    <DatePicker
                        Format={this.dateFormat}
                        value={filter ? filter.value : null}
                        onChange={date => onChange(date)}
                    />
                )
            },
            {
                Header: "End Date",
                accessor: original => moment(original.endDate),
                id: "endDate",
                Cell: ({ original, index }) => {
                    const rowId = draftsDetails[index].id;
                    const endDate =
                        original.endDate !== "" ? moment(original.endDate) : null;
                    const startDate =
                        original.startDate !== "" ? moment(original.startDate) : null;
                    const value = original.endDate;
                    const draftId = draftsDetails[index].draftId;

                    return (
                        <MenuProvider
                            id={bulkEditMenuId}
                            data={this.bulkEditData(
                                "endDate",
                                value
                            )}
                        >
                            {inputsReadOnly[draftId]
                                ?
                                <Form.Control
                                    type="text"
                                    defaultValue={endDate ? endDate.format(this.dateFormat) : ""}
                                    disabled={inputsReadOnly[draftId]}
                                />
                                :
                                <DatePicker
                                    value={endDate}
                                    format={this.dateFormat}
                                    onChange={date => {
                                        const dateString = date === null ? "" : date.format(this.dateFormat);
                                        this.onInputBlur(rowId, "endDate", dateString, false);
                                    }}
                                    disabled={inputsReadOnly[draftId]}
                                    disabledDate={(current) => current && current < startDate}
                                    allowClear={false}
                                />
                            }
                        </MenuProvider>
                    );
                },
                Filter: ({ filter, onChange }) => (
                    <DatePicker
                        Format={this.dateFormat}
                        onChange={date => onChange(date)}
                        value={filter ? filter.value : null}
                    />
                )
            },
            {
                Header: "Previous Merchandiser(s)",
                id: "previousWorkers",
                width: 220,
                resizable: false,
                accessor: original => (original.previousWorkers !== null &&
                        original.previousWorkers !== undefined
                            ? original.previousWorkers.map(item => item.name).join("")
                            : ""),
                Cell: ({ original }) => (
                    <WorkersList
                        workers={original.previousWorkers}
                        hideActions={true}
                        hasHelperJob={!!original.helperJobProduct}
                        onWorkerDetailsClick={ (workerId) => handleWorkerProfileModal(workerId)}
                    />
                )
            },
            {
                Header: "Current Merchandiser(s)",
                id: "workers",
                width: 300,
                resizable: false,
                accessor: original => (original.workers !== null && original.worker !== undefined
                    ? original.workers.map(item => item.name).join("")
                    : ""),
                Cell: ({ index, original }) => {
                    // console.error("index, original", original);
                    const draftId = draftsDetails[index].draftId;
                    return (
                        <WorkersList
                            rowIndex={index}
                            workers={original.workers}
                            hasHelperJob={!!original.helperJobProduct}
                            hideActions={inputsReadOnly[draftId]}
                            onWorkerAddClick={() =>
                                handleModal(
                                    "",
                                    index,
                                    false,
                                )
                            }
                            onWorkerRemoveClick={(workerRowId) => {
                                handleDeleteWorker(
                                    original.id,
                                    workerRowId
                                );
                            }}
                            onWorkerDetailsClick={(workerId) => handleWorkerProfileModal(workerId)}
                            onWorkerSearchClick={ (workerIndex) =>
                                handleModal(
                                    "replace",
                                    index,
                                    workerIndex
                                )
                            }
                            onWorkerReplaceClick={oldWorkerId =>
                                handleModal(
                                    "replaceAll",
                                    index,
                                    undefined,
                                    {
                                        oldWorkerId
                                    }
                                )
                            }
                            onWorkerToggleTemporaryClick={handleClickCurrentWorker}
                            filterable={false}
                            onSortedChange={this.handleSortedChange}
                            onPageChange={this.handlePageChange}
                            onPageSizeChange={this.handlePageSizeChange}
                        />
                    );
                },
                getProps: () => ({
                    style: {
                        justifyContent: "space-between",
                        whiteSpace: "unset"
                    }
                })
            }
        ];

        return (
            <div>
                <ReactTable
                    data={draftsDetails}
                    headerClassName="table-header"
                    columns={columns}
                    defaultPageSize={20}
                    pageSizeOptions={[10, 20, 50, 100, 1000]}
                    pages={pages}
                    page={page}
                    resizable
                    className="-striped -highlight"
                    loading={loading}
                    ref={this.reactTable}
                    onFilteredChange={(filtered, column) =>
                        this.onTableViewChange(filtered, column)
                    }
                    // onFetchData={this.fetchTableData}
                    onSortedChange={this.handleSortedChange}
                    onPageChange={this.handlePageChange}
                    onPageSizeChange={this.handlePageSizeChange}
                    defaultFilterMethod={this.filterCaseInsensitive}
                    defaultSorted={[
                        {
                            id: "retailer",
                            desc: false
                        }
                    ]}
                    style={{
                        height: "calc(100vh - 260px)"
                    }}
                    getTdProps={() => ({
                        style: {
                            borderBottom: "1px solid rgba(0,0,0,0.02)",
                            display: "flex",
                            alignItems: "center"
                        }
                    })}
                    filterable={false}
                    manual={true}
                />

                <BulkEditContextMenu />
                <WorkerContextMenu />
            </div>
        );
    }
}

DetailsTable.propTypes = {
    page: PropTypes.number.isRequired,
    draftsDetails: PropTypes.array.isRequired,
    inputsReadOnly: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    handleClickCurrentWorker: PropTypes.func.isRequired,
    handleBulkEdit: PropTypes.func.isRequired,
    handleWorkerProfileModal: PropTypes.func.isRequired,
    handleTableChange: PropTypes.func.isRequired,
    handleRefreshPage: PropTypes.func.isRequired,
    batchEditCell: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    loading: state.draft.loading,
    serviceTypes: state.serviceTypes.serviceTypes,
});

const mapStateToDispatch = dispatch => ({
    fetchServiceTypes: bindActionCreators(fetchServiceTypes, dispatch),
    updateJob: bindActionCreators(updateJob, dispatch),
    batchEditCell: bindActionCreators(batchEditCell, dispatch),
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(DetailsTable);
